// "confluence.fe.custom.XXX"
export const MENTIONS_QUERY_CUSTOM_KEY = 'mentions-query';
export const PROFILE_CARD_QUERY_CUSTOM_KEY = 'profile-card-query';
export const LEGACY_EXTENSION_LOADING_CUSTOM_KEY = 'legacy-extension-loading';
export const FABRIC_PUBLISH_PAGE_KEY = 'fabric-publish-page';
export const TIME_TO_APP_IDLE_KEY = 'time-to-app-idle';
export const SHARE_FROM_RESTRICTIONS_KEY = 'share-notif-from-restrictions';

export const TEAM_CALENDARS_EVENT_FETCH_KEY = 'tc-events-fetch';

export const TEAM_CALENDARS_SUBCALS_FETCH_KEY = 'tc-subcals-fetch';
export const TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY = 'tc-jira-projects-fetch';
